module.exports = __webpack_public_path__ + "assets/images/17-30fakhT.jpeg";